import { useEffect } from 'react'

import {
  COMMAND_PRIORITY_CRITICAL,
  COMMAND_PRIORITY_EDITOR,
  PASTE_COMMAND
} from 'lexical'

import { useFileDialog } from '@eastcoal/common/hooks/useFileDialog'
import { isImage } from '@eastcoal/common/utils/mimeType'

import { useEditor } from '../../hooks/useEditor'
import { $createImageNode, ImageNode } from '../../nodes/ImageNode'
import { $insertIsolatedNodeToNearestRoot } from '../../utils/node'

import { INSERT_IMAGE_COMMAND, UPLOAD_IMAGE_COMMAND } from './commands'

export const ImagePlugin = () => {
  const editor = useEditor()

  const { attrs, openFileDialog } = useFileDialog(files => {
    for (const file of files) {
      editor.dispatchCommand(INSERT_IMAGE_COMMAND, { file })
    }
  })

  // 打开文件对话框
  useEffect(() => {
    return editor.registerCommand(
      UPLOAD_IMAGE_COMMAND,
      () => {
        openFileDialog()
        return true
      },
      COMMAND_PRIORITY_EDITOR
    )
  }, [editor, openFileDialog])

  // 插入图片节点
  useEffect(() => {
    if (!editor.hasNode(ImageNode)) {
      throw new Error('ImagesPlugin: ImageNode not registered on editor')
    }
    return editor.registerCommand(
      INSERT_IMAGE_COMMAND,
      payload => {
        const imageNode = $createImageNode(payload)
        $insertIsolatedNodeToNearestRoot(imageNode)
        return false
      },
      COMMAND_PRIORITY_EDITOR
    )
  }, [editor])

  // 从剪切板中粘贴上传
  useEffect(() => {
    return editor.registerCommand(
      PASTE_COMMAND,
      payload => {
        if (payload instanceof InputEvent && payload.dataTransfer) {
          for (const file of payload.dataTransfer.files) {
            if (isImage(file.type)) {
              editor.dispatchCommand(INSERT_IMAGE_COMMAND, { file })
            }
          }
        }
        return false
      },
      COMMAND_PRIORITY_CRITICAL
    )
  }, [editor])

  return <input {...attrs} multiple accept='image/*' />
}
